<template>
    <div class="stocks">
      <div class="banner-top">
        <div class="banner-box"></div>
        <div class="banner-desc">多维度挖掘最具有潜力的投资标的</div>
      </div>
      <div class="stocks-box">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, i) in menuList" :key="i">
            <el-tooltip class="item" effect="light" :content="item.desc" placement="bottom" popper-class="fourth-tooltip">
            <div class="grid-content bg-purple cursorPointer" @click="token && selectMenu(i)">
              <div :class="currentIndex === i ? 'active' : ''"><img class="small-img" :src="currentIndex === i ? item.imgUrl : item.imgUrls" alt="">{{item.txt}}</div>
            </div>
            </el-tooltip>
          </el-col>
        </el-row>

        <div class="list" v-show="currentIndex === ''">
          <div class="list-box" v-for="(item,i) in itemList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom b-width"><span>{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }} </span><span>{{item.apply_date}}</span></div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 0">
          <div class="block xg">
<!--            <span class="demonstration"></span>-->
            <el-date-picker
              v-model="value1"
              type="datetime"
              format='yyyy-MM-dd'
              value-format='yyyy-MM-dd'
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
          <div class="zx-list">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
<!--              <el-tab-pane label="全部" name="first">-->
<!--              <div class="main-content">-->
<!--                  <div class="left">-->
<!--                    <div class="list-box" v-for="(item,i) in itemXgList" :key="i">-->
<!--                      <div class="img-box">-->
<!--                        <img class="thumb-img" :src="item.img" alt="">-->
<!--                      </div>-->
<!--                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">-->
<!--                        <div class="article_title">-->
<!--                          <div class="title">{{ item.title }}</div>-->
<!--                          <div class="list-content">{{ item.desc }}</div>-->
<!--                          <div class="list-bottom"><span>{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }} </span><span>{{item.apply_date}}</span></div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                <div class="right">-->
<!--                  <div class="recommend">-->
<!--                    <div class="top">-->
<!--                      <div class="title">最新推荐</div>-->
<!--                    </div>-->
<!--                    <div class="recommend-list">-->
<!--                      <ul id="recommendList">-->
<!--                        <li v-for="(item, i) in itemTjAllList" :key="i">-->
<!--                          <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">-->
<!--                            <img :src="item.img">-->
<!--                            <div class="recommend-title">{{ item.title }}</div>-->
<!--                            <div class="recommend-bottom">-->
<!--                              {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                            </div>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="more">-->
<!--                <div class="cursorPointer">-->
<!--                  <div @click="getXgMore();getXgTjMore()">点击加载更多...</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              </el-tab-pane>-->
              <el-tab-pane label="申购日" name="second">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemSgList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom"><span>{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }} </span><span>{{item.apply_date}}</span></div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-dx">
                          <li v-for="(item, i) in itemSgTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getSgMore();getSgTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="上市日" name="third">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemSsList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom"><span>{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }} </span><span>{{item.apply_date}}</span></div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-yx">
                          <li v-for="(item, i) in itemSsTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getSsMore();getSsTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

        </div>

        <div class="list" v-show="currentIndex === 1">
          <div class="zx-list">
            <el-tabs v-model="activeRgName" type="card" @tab-click="handleClick">
              <el-tab-pane label="全部" name="fourth">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemRgList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-rg">
                          <li v-for="(item, i) in itemRgTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getRgMore();getRgTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="涨停分析" name="five">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemFxList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-rg1">
                          <li v-for="(item, i) in itemFxTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getFxMore();getFxTjMore();">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="涨停预测" name="six">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemYcList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-rg2">
                          <li v-for="(item, i) in itemYcTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getYcMore();getYcTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="强势股解析" name="seven">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemJxList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-rg3">
                          <li v-for="(item, i) in itemJxTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getJxMore();getJxTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
<!--
        <div class="list" v-show="currentIndex === 2">
          <div class="zx-list">
            <el-tabs v-model="activeKcName" type="card" @tab-click="handleClick">
              <el-tab-pane label="全部" name="eight">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemKcList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-kc">
                          <li v-for="(item, i) in itemKcTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getKcMore();getKcTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="研选" name="ten">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemYxList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-kc2">
                          <li v-for="(item, i) in itemYxTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getYxMore();getYxTjMore();">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="图研" name="nine">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemTyList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-kc1">
                          <li v-for="(item, i) in itemTyTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=stocks'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getTyMore();getTyTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
-->
        <div class="tool-list" v-show="currentIndex === 2">
          <div class="tool-box">
             <el-tooltip class="item" effect="light" content="大数据诊股神器，多维度评估个股市场价值" placement="bottom" popper-class="zn-tooltip">
              <div @click="showZgLink('http://develop.bolanjr.com/#/')" class="zg"></div>
            </el-tooltip>

            <el-tooltip class="item" effect="light" content="大数据诊股神器，多维度评估个股市场价值" placement="bottom" popper-class="zn-tooltip">
              <div @click="showZgLink('http://develop.bolanjr.com/#/')" class="zg"></div>
            </el-tooltip>
          </div>

        </div>

      </div>
      <div class="back-top" @click="backTop" v-show="btnFlag">
        <img src="../assets/images/return_top.png" alt="" srcset="">
      </div>
    </div>
</template>

<script>
import { StocksAll, XgList, RgList, KcList, ZxAllList, RgTjList, ZtFxList, FxTjList, ZtYcList, YcTjList, JxList, JxTjList, KcTjList, TyList ,TyTjList, KcYxList ,KcYxTjList, SgList, SgTjList, SsList, SsTjList, innovation } from "@/api/news";
import { BolanRole } from "@/api/user";
export default {
  name: "Stocks",
  data() {
    return {
      itemList: [],
      value1: '',
      itemXgList: [],
      itemRgList: [],
      itemFxList: [],
      itemYcList: [],
      itemJxList: [],
      itemRgTjList: [],
      itemFxTjList: [],
      itemYcTjList: [],
      itemJxTjList: [],
      itemKcTjList: [],
      itemTyTjList: [],
      itemYxTjList: [],
      itemSgTjList: [],
      itemSgList: [],
      itemSsTjList: [],
      itemSsList: [],
      itemKcList: [],
      itemYxList: [],
      itemTyList: [],
      itemTjAllList:[],
      currentTab:'second',
      activeName: 'second',
      currentRgTab:'fourth',
      activeRgName: 'fourth',
      currentKcTab:'eight',
      activeKcName: 'eight',
      token: window.localStorage.getItem('token'),
      btnFlag: false,
      page: 1,
      xgPage: 1,
      xgTjPage: 1,
      rgPage: 1,
      rgTjPage: 1,
      fxPage: 1,
      fxTjPage: 1,
      ycPage: 1,
      ycTjPage: 1,
      jxPage: 1,
      jxTjPage: 1,
      kcPage: 1,
      kcTjPage: 1,
      tyPage: 1,
      tyTjPage: 1,
      yxPage: 1,
      yxTjPage: 1,
      sgPage: 1,
      sgTjPage: 1,
      ssPage: 1,
      ssTjPage: 1,
      currentIndex:'',
      menuList:[
        {
          imgUrl: require('../assets/images/icon_新股2.png'),
          imgUrls: require('../assets/images/icon_新股1.png'),
          txt: '新股',
          desc: '一站式打新指南（更新频率：新股申购日盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_热股2.png'),
          imgUrls: require('../assets/images/icon_热股1.png'),
          txt: '热股',
          desc: '跟踪强势个股，把握超短时机（更新频率：交易日盘前/盘后）'
        },
        
        {
          imgUrl: require('../assets/images/icon_智选2.png'),
          imgUrls: require('../assets/images/icon_智选1.png'),
          txt: '智选',
          desc: '人工智能结合专业实力，最核心研报逻辑直击个股核心价值；大数据诊股神器，多维度评估个股市场价值（更新频率：交易日实时更新）'
        },
      ]
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getStocksAllList()
    // this.getXgList()
    // this.getAllZxList()
    // this.getSgList()
    // this.getSgTjList()
    // this.getSsList()
    // this.getSsTjList()
    // this.getRgList()
    // this.getZtFxList()
    // this.getRgTjList()
    // this.getZtYcList()
    // this.getJxList()
    // this.getFxTjList()
    // this.getYcTjList()
    // this.getJxTjList()
    // this.getKcList()
    // this.getKcTjList()
    // this.getTyList()
    // this.getTyTjList()
    // this.getYxList()
    // this.getYxTjList()
  },
  mounted() {
    this.toJump()
    this.toRgJump()
    this.toKcJump()
    this.market()
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      if (tab.name == 'first') {
        this.itemXgList = []
        this.itemTjAllList = []
        this.getXgList()
        this.getAllZxList()
      }else if(tab.name == 'second'){
        this.itemSgList = []
        this.itemSgTjList = []
        this.getSgList()
        this.getSgTjList()
        // let id = 'g9gqqkic29'
        // let date = this.value1
        // console.log(date);
        // if(date !== ''){
        //   this.itemSgList = []
        //   this.getInnovation(id, date)
        // }
      }else if(tab.name == 'third'){
        this.itemSsList = []
        this.itemSsTjList = []
        this.getSsList()
        this.getSsTjList()
        // let id = '24fa1zkzu3c'
        // let date = this.value1
        // console.log(date);
        // if(date !== ''){
        //   this.itemSsList = []
        //   this.getInnovation(id, date)
        // }
      }else if(tab.name == 'fourth'){
        this.itemRgList = []
        this.itemRgTjList = []
        this.getRgList()
        this.getRgTjList()
      }else if(tab.name == 'five'){
        this.itemFxList = []
        this.itemFxTjList = []
        this.getZtFxList()
        this.getFxTjList()
      }else if(tab.name == 'six'){
        this.itemYcList = []
        this.itemYcTjList = []
        this.getZtYcList()
        this.getYcTjList()
      }else if(tab.name == 'seven'){
        this.itemJxList = []
        this.itemJxTjList = []
        this.getJxList()
        this.getJxTjList()
      }else if(tab.name == 'eight'){
        this.itemKcList = []
        this.itemKcTjList = []
        this.getKcList()
        this.getKcTjList()
      }else if(tab.name == 'nine'){
        this.itemTyList = []
        this.itemTyTjList = []
        this.getTyList()
        this.getTyTjList()
      }else if(tab.name == 'ten'){
        this.itemYxList = []
        this.itemYxTjList = []
        this.getYxList()
        this.getYxTjList()
      }
    },
    market(){
      let tabIndex = this.$route.query.currentTab
      let tabIndexKc = this.$route.query.currentKcTab
      let tabIndexRg = this.$route.query.currentRgTab
      if (tabIndex  == 'first') {
        this.itemXgList = []
        this.itemTjAllList = []
        this.getXgList()
        this.getAllZxList()
      }else if(tabIndex  == 'second'){
        this.itemSgList = []
        this.itemSgTjList = []
        this.getSgList()
        this.getSgTjList()
      }
      else if(tabIndex  == 'third'){
        this.itemSsList = []
        this.itemSsTjList = []
        this.getSsList()
        this.getSsTjList()
      }
      else if(tabIndexRg  == 'fourth'){
        this.itemRgList = []
        this.itemRgTjList = []
        this.getRgList()
        this.getRgTjList()
      }else if(tabIndex  == 'five' || tabIndexRg == 'five') {
        this.itemFxList = []
        this.itemFxTjList = []
        this.getZtFxList()
        this.getFxTjList()
      }else if(tabIndex  == 'six' || tabIndexRg == 'six') {
        this.itemYcList = []
        this.itemYcTjList = []
        this.getZtYcList()
        this.getYcTjList()
      }else if(tabIndex  == 'seven' || tabIndexRg == 'seven') {
        this.itemJxList = []
        this.itemJxTjList = []
        this.getJxList()
        this.getJxTjList()
      }else if(tabIndexKc  == 'eight') {
        this.itemKcList = []
        this.itemKcTjList = []
        this.getKcList()
        this.getKcTjList()
      }else if(tabIndex  == 'nine' || tabIndexKc == 'nine') {
        this.itemTyList = []
        this.itemTyTjList = []
        this.getTyList()
        this.getTyTjList()
      }else if(tabIndex  == 'ten' || tabIndexKc == 'ten') {
        this.itemYxList = []
        this.itemYxTjList = []
        this.getYxList()
        this.getYxTjList()
      }
    },
    toJump(){
      if(this.$route.query.activeName!=null){
        this.activeName = this.$route.query.activeName;
        this.currentTab = this.$route.query.currentTab;
        const currentSt = this.currentTab;
        // console.log(currentSt);
        if(currentSt ==='first' || currentSt ==='second' || currentSt ==='third'){
          this.currentIndex = 0
        }else if(currentSt === 'one'){
          this.currentIndex = 3
        }
      }
    },
    toRgJump(){
      if(this.$route.query.activeRgName!=null){
        this.activeRgName = this.$route.query.activeRgName;
        this.currentRgTab = this.$route.query.currentRgTab;
        const currentRg = this.currentRgTab;
        // console.log(currentRg);
        if(currentRg ==='fourth' || currentRg ==='five' || currentRg ==='six' || currentRg ==='seven'){
          this.currentIndex = 1
        }
      }
    },
    toKcJump(){
      if(this.$route.query.activeKcName!=null){
        this.activeKcName = this.$route.query.activeKcName;
        this.currentKcTab = this.$route.query.currentKcTab;
        const currentKc = this.currentKcTab;
        // console.log(currentKc);
        if(currentKc ==='eight' || currentKc ==='nine' || currentKc ==='ten'){
          this.currentIndex = 2
        }
      }
    },
    getInnovation(id, date) {
      innovation({id: id, date: date}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          if(id === 'g9gqqkic29'){
            this.itemSgList = this.itemSgList.concat(response.data.data)
          }
          if(id === '24fa1zkzu3c'){
            this.itemSsList = this.itemSsList.concat(response.data.data)
          }
        }
      });
    },
    showYxLink(url) {
      BolanRole({}).then((response) => {
        if (response.code === 2000) {
          let str = '诊股,研选,投研库'
          let role = response.data.toString()
          let n = str.includes(role)
          if (n === true && response.data.length !==0){
            window.open(url,'_blank')
          }
        }
      });
    },
    showZgLink(url) {
      BolanRole({}).then((response) => {
        if (response.code === 2000) {
          let str = '诊股,研选,投研库'
          let role = response.data.toString()
          let n = str.includes(role)
          if (n === true && response.data.length !==0){
            window.open(url,'_blank')
          }
        }
      });
    },
    selectMenu(index) {
      if(index === 1){
        this.itemRgList = []
        this.itemRgTjList = []
        this.getRgList()
        this.getRgTjList()
      }
      if(index === 2){
        this.itemKcList = []
        this.itemKcTjList = []
        this.getKcList()
        this.getKcTjList()
      }
      if(index === 0){
        this.itemSgList = []
        this.itemSgTjList = []
        this.getSgList()
        this.getSgTjList()
      }
      this.currentIndex = index
    },
    getStocksAllList() {
      StocksAll({id: '24bqdgymhxa', page: this.page}).then((response) => {
        if (response.code === 2000  || response.code === 505 || response.code === 403) {
          this.itemList = this.itemList.concat(response.data.data)
        }
      });
    },
    getXgList() {
      XgList({id: '1hhd06p8itj', page: this.xgPage, date:''}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemXgList = this.itemXgList.concat(response.data.data)
        }
      });
    },
    getRgList() {
      RgList({id: 'f2xcx498kj', page: this.rgPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemRgList = this.itemRgList.concat(response.data.data)
        }
      });
    },
    getKcList() {
      KcList({id: 'u59l7stx0x', page: this.kcPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemKcList = this.itemKcList.concat(response.data.data)
        }
      });
    },
    getKcTjList() {
      KcTjList({id:'2bwoal5oysw',limit: 3, page: this.kcTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemKcTjList = this.itemKcTjList.concat(response.data.data)
        }
      });
    },
    getTyList() {
      TyList({id: '17560ufm1sw', page: this.tyPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTyList = this.itemTyList.concat(response.data.data)
        }
      });
    },
    getTyTjList() {
      TyTjList({id:'2bwoal5oysw',limit: 3, page: this.tyTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTyTjList = this.itemTyTjList.concat(response.data.data)
        }
      });
    },
    getYxList() {
      KcYxList({id: '2eyk6mg0tp8', page: this.yxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemYxList = this.itemYxList.concat(response.data.data)
        }
      });
    },
    getYxTjList() {
      KcYxTjList({id:'2bwoal5oysw',limit: 3, page: this.yxTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemYxTjList = this.itemYxTjList.concat(response.data.data)
        }
      });
    },
    getSgList() {
      SgList({id: 'g9gqqkic29', page: this.sgPage, date:''}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemSgList = this.itemSgList.concat(response.data.data)
        }
      });
    },
    getSgTjList() {
      SgTjList({id:'2bwoal5oysw',limit: 3, page: this.sgTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemSgTjList = this.itemSgTjList.concat(response.data.data)
        }
      });
    },
    getSsList() {
      SsList({id: '24fa1zkzu3c', page: this.ssPage, date:''}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemSsList = this.itemSsList.concat(response.data.data)
        }
      });
    },
    getSsTjList() {
      SsTjList({id:'2bwoal5oysw',limit: 3, page: this.ssTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemSsTjList = this.itemSsTjList.concat(response.data.data)
        }
      });
    },
    getAllZxList() {
      ZxAllList({id:'2bwoal5oysw',limit: 3, page: this.xgTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTjAllList = this.itemTjAllList.concat(response.data.data)
        }
      });
    },
    getRgTjList(){
      RgTjList({id:'2bwoal5oysw',limit: 3, page: this.rgTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemRgTjList = this.itemRgTjList.concat(response.data.data)
        }
      });
    },
    getZtFxList() {
      ZtFxList({id: '2pearwfieb6', page: this.fxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemFxList = this.itemFxList.concat(response.data.data)
        }
      });
    },
    getFxTjList(){
      FxTjList({id:'2bwoal5oysw',limit: 3, page: this.fxTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemFxTjList = this.itemFxTjList.concat(response.data.data)
        }
      });
    },
    getZtYcList() {
      ZtYcList({id: 'yh8efcfcca', page: this.ycPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemYcList = this.itemYcList.concat(response.data.data)
        }
      });
    },
    getYcTjList(){
      YcTjList({id:'2bwoal5oysw',limit: 3, page: this.ycTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemYcTjList = this.itemYcTjList.concat(response.data.data)
        }
      });
    },
    getJxList() {
      JxList({id: 'weslragvw7', page: this.jxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemJxList = this.itemJxList.concat(response.data.data)
        }
      });
    },
    getJxTjList(){
      JxTjList({id:'2bwoal5oysw',limit: 3, page: this.jxTjPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemJxTjList = this.itemJxTjList.concat(response.data.data)
        }
      });
    },
    getMore() {
      this.page++;
      this.getStocksAllList()
    },
    getXgMore() {
      this.xgPage++;
      this.getXgList()
    },
    getXgTjMore() {
      this.xgTjPage++;
      this.getAllZxList()
    },
    getRgMore() {
      this.rgPage++;
      this.getRgList()
    },
    getRgTjMore() {
      this.rgTjPage++;
      this.getRgTjList()
    },
    getFxMore() {
      this.fxPage++;
      this.getZtFxList()
    },
    getFxTjMore() {
      this.fxTjPage++;
      this.getFxTjList()
    },
    getYcMore() {
      this.ycPage++;
      this.getZtYcList()
    },
    getYcTjMore() {
      this.ycTjPage++;
      this.getYcTjList()
    },
    getJxMore() {
      this.jxPage++;
      this.getJxList()
    },
    getJxTjMore() {
      this.jxTjPage++;
      this.getJxTjList()
    },
    getKcMore() {
      this.kcPage++;
      this.getKcList()
    },
    getKcTjMore() {
      this.kcTjPage++;
      this.getKcTjList()
    },
    getTyMore() {
      this.tyPage++;
      this.getTyList()
    },
    getTyTjMore() {
      this.tyTjPage++;
      this.getTyTjList()
    },
    getYxMore() {
      this.yxPage++;
      this.getYxList()
    },
    getYxTjMore() {
      this.yxTjPage++;
      this.getYxTjList()
    },
    getSgMore() {
      this.sgPage++;
      this.getSgList()
    },
    getSgTjMore() {
      this.sgTjPage++;
      this.getSgTjList()
    },
    getSsMore() {
      this.ssPage++;
      this.getSsList()
    },
    getSsTjMore() {
      this.ssTjPage++;
      this.getSsTjList()
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
  }
}
</script>

<style scoped>
.stocks {
  background-color: #F5F7FA;
}
.stocks-box {
  width: 1200px;
  margin: -30px auto 0;
}
.active{
  color: #ffe400;
}
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  height: 60px;
  color: white;
  background-image: linear-gradient(#0c255c, #040f27);
  line-height: 60px;
  font-size: 16px;
  padding-left: 50px;
}

.cursorPointer {
  cursor: pointer;
}

.small-img {
  height: 30px;
  padding-right: 20px;
  vertical-align: middle;
}

.block{
  position: absolute;
  z-index: 999;
  right: 410px;
  display: none;
}

.zx-list {
  width: 1200px;
  margin-top: 10px;
  display: flex;
}

.main-content{
  display: flex;
  width: 1200px;
}

.zx-list .left {
  width: 900px;
  margin-right: 10px;
}

.zx-list .right {
  width: 300px;
  margin-top: -44px;
}

.zx-list .right .recommend .recommend-list:not(:first-child) {
  padding: 30px 0;
  background: #fff;
  margin-top: 14px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.zx-list .right .recommend .recommend-list ul {
  width: 260px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li:not(:last-child) {
  border-bottom: 1px solid #cdcdcd;
  margin-bottom: 30px;
}

.zx-list .right .recommend .recommend-list li img {
  width: 260px;
  height: 120px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li .recommend-title {
  margin: 15px 0;
  font-size: 14px;
  color: #313131;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.zx-list .right .recommend .top .title {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  background-image: linear-gradient(#0c255c, #040f27);
}

.zx-list .right .recommend .recommend-list li .recommend-bottom {
  font-size: 12px;
  color: #898989;
  margin-bottom: 23px;
}

.list {
  margin: 10px 0;
  position: relative;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  min-width: 570px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.b-width{
  min-width: 860px;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}

.el-table__row{
  cursor: pointer;
}

.el-tabs__item {
  width: 160px;
  text-align: center;
  color: #313131;
  background-color: #FFFFFF;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}

 .is-active {
  color: #FFFFFF;
  height: 30px;
  background-image: linear-gradient(#0c255c, #040f27);
}

.el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #E4E7ED;
  margin-right: 10px;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

.tool-box {
  display: flex;
  margin-top: 20px;
  justify-content: space-around;
  padding-bottom: 200px;
}

.tool-box > div{
  width: 500px;
  height: 360px;
  text-align: center;
  line-height: 360px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}


.zg{
  background: url("../assets/images/AI诊股.jpg") no-repeat;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Stocks.vue